import React, { Fragment, forwardRef } from 'react';
import { useField } from 'formik';
import StyledInput from '../StyledInput';

const FormInput = forwardRef(({ label, ...props }, ref) => {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);

  // console.log('=== FORM INPUT ===');
  // console.log(`label: ${label}`);
  // console.log(props);
  // console.log(field);
  // console.log(meta);

  return (
    <Fragment>
      <StyledInput
        ref={ref}
        {...field}
        {...props}
        label={label}
        error={meta.touched && Boolean(meta.error)}
        helperText={meta.touched && meta.error}
      />
    </Fragment>
  );
});

export default FormInput;
